export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-background-50 pt-16 md:pt-20 pb-20 md:pb-24">
      {/* Subtle gradient blob */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] md:w-[800px] h-[300px] md:h-[400px] bg-primary-500/8 rounded-full blur-3xl -z-0" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Trust badge */}
        <div className="inline-flex items-center gap-2 bg-primary-100 text-primary-700 border border-primary-200 rounded-full px-4 py-1.5 text-sm font-medium mb-6 md:mb-8">
          <i className="ri-star-fill text-primary-500 text-xs w-3 h-3 flex items-center justify-center" />
          Trusted by 36,000+ learners worldwide
        </div>

        {/* Headline */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-tight text-balance leading-tight">
          Master{' '}
          <span className="text-primary-500">Artificial</span>
          <br className="hidden sm:block" />
          Intelligence.
          <br />
          <span className="text-foreground-400">From Zero to Deployed.</span>
        </h1>

        {/* Subtext */}
        <p className="mt-4 md:mt-6 text-base sm:text-lg md:text-xl text-foreground-600 max-w-2xl mx-auto text-balance">
          Expert-led courses on ChatGPT, Machine Learning, AI Agents, and building with AI APIs — practical skills you can use tomorrow.
        </p>

        {/* CTAs */}
        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
          <a
            href="#courses"
            className="inline-flex shrink-0 items-center justify-center font-medium whitespace-nowrap transition-all outline-none bg-primary-500 text-background-50 hover:bg-primary-600 h-10 rounded-md text-base px-8 gap-2"
          >
            Explore Courses
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
          </a>
          <a
            href="#features"
            className="inline-flex shrink-0 items-center justify-center gap-2 font-medium whitespace-nowrap transition-all outline-none bg-background-100 text-foreground-900 hover:bg-background-200 h-10 rounded-md text-base px-8 border border-background-200"
          >
            How it works
          </a>
        </div>

        {/* Hero image with floating stats */}
        <div className="mt-12 md:mt-16 relative mx-auto max-w-5xl">
          <div className="rounded-2xl overflow-hidden border border-background-200 shadow-lg">
            <img
              alt="AI course platform"
              className="w-full h-56 sm:h-72 md:h-96 object-cover object-top"
              src="https://images.unsplash.com/photo-1677442135703-1787eea5ce01?w=1200&q=80"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-2xl" />
          </div>

          {/* Floating stat - left */}
          <div className="absolute -left-2 sm:-left-6 top-1/2 -translate-y-1/2 bg-background-50 rounded-xl shadow-lg border border-background-200 p-3 hidden sm:block">
            <p className="text-xs text-foreground-500">Courses available</p>
            <p className="text-2xl font-bold text-foreground-950">4</p>
          </div>

          {/* Floating stat - right */}
          <div className="absolute -right-2 sm:-right-6 top-1/2 -translate-y-1/2 bg-background-50 rounded-xl shadow-lg border border-background-200 p-3 hidden sm:block">
            <p className="text-xs text-foreground-500">Happy students</p>
            <p className="text-2xl font-bold text-foreground-950">36k+</p>
          </div>
        </div>
      </div>
    </section>
  );
}